module.exports = __webpack_public_path__ + "static/media/bv-logo-black.1e833d31.svg";